import { Request } from '@/classes/Request.ts'

export const removeActivityFee = async (
  districtId: number,
  activityFeeId: number
): Promise<void> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/remove_activity_fee/${districtId}`, {
        fee_id: activityFeeId
      })
      .then(() => {
        resolve()
      })
      .catch(err => {
        reject(err.responseText)
      })
  })
}
